import { Component, EventEmitter, HostListener, OnInit, Output, ChangeDetectionStrategy } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { BasePaths } from "src/app/constants/routes";
import { USStates } from "src/app/constants/us-states";
import { AuthService } from "src/app/services/auth.service";
import { AgentLoginCredentials } from "src/app/models/agent";
import { AgentLocationType } from "src/app/constants/agent";
import { AdminDirectSystemLocation } from "src/app/constants/admin-direct-system";
import { SessionService } from "src/app/services/storage/session.service";
import { AuthenticatorInfo, MultiFactorAuthenticator } from "src/app/models/authenticator";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-login-form-counselor',
    templateUrl: './login-form-counselor.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class LoginFormCounselorComponent implements OnInit {
    @Output() public emitMultiFactorAuthenticator: EventEmitter<MultiFactorAuthenticator> = new EventEmitter();
    public loginForm: FormGroup;
    public route = BasePaths;
    public usStates = USStates;
    public agentLocationEnum = AgentLocationType;
    public displayWorkSiteInfo: boolean;
    public reCaptchaTokenId: string = "reCaptchaTokenId";
    public reCaptchaToken: string = "reCaptchaToken";
    public useSecondaryCaptcha: boolean;

    @HostListener('window:keydown.enter', ['$event']) onEnter(e: Event): void {
        if (e instanceof KeyboardEvent)
            e.preventDefault();

        if (this.loginForm.valid)
            this.submitLogIn();
		e.preventDefault();
	}

    constructor(
        private formBuilder: FormBuilder,
        private authService: AuthService,
        private sessionService: SessionService,
        private helperService: HelperService,
    ) {
        this.useSecondaryCaptcha = this.sessionService.session.operatingMode.useSecondaryCaptcha;
    }

    ngOnInit() {
        this.loginForm = this.formBuilder.group({
            username: [null, Validators.required],
            currentPassword: [null, Validators.required],
            [this.reCaptchaTokenId]: [null],
            [this.reCaptchaToken]: [null, Validators.required],
            agentLocation: [null, Validators.required],
        });
    }

    public submitLogIn(): void {
        // Security: Simple Bot bypass form validation prevention
        if (!this.loginForm.get(this.reCaptchaToken).value)
            return;

        const l_Payload = new AgentLoginCredentials();
        l_Payload.username = this.loginForm.get('username').value;
        l_Payload.password = this.loginForm.get('currentPassword').value;
        l_Payload.adminDirectSystem = this.loginForm.get('agentLocation').value;

        if (l_Payload.adminDirectSystem == AdminDirectSystemLocation.Laptop) {
            l_Payload.agentCity = this.loginForm.get('location').get('agentCity').value;
            l_Payload.agentState = this.loginForm.get('location').get('agentState').value;
        }

        l_Payload.reCaptchaID = this.loginForm.get(this.reCaptchaTokenId).value;
        l_Payload.reCaptchaToken = this.loginForm.get(this.reCaptchaToken).value;

        this.authService.agentLogin(l_Payload).subscribe((response: AuthenticatorInfo) => {
            const l_MultiFactorAuthenticator:MultiFactorAuthenticator = this.helperService.convertObjectIntoObject(response, new MultiFactorAuthenticator());
            l_MultiFactorAuthenticator.adminDirectSystem = l_Payload.adminDirectSystem;
            l_MultiFactorAuthenticator.agentCity = l_Payload.agentCity;
            l_MultiFactorAuthenticator.agentState = l_Payload.agentState;
            this.emitMultiFactorAuthenticator.emit(l_MultiFactorAuthenticator);
        });
    }

    public reloadCaptcha(useSecondary: boolean): void {
        this.useSecondaryCaptcha = useSecondary;
        this.sessionService.session.operatingMode.useSecondaryCaptcha = useSecondary;
        this.sessionService.setSession();
    }
}